import React, { useMemo, useState } from 'react';
import { useMaestroContext } from '../../context/MaestroContext';
import { ProdutoIntegrado, TipoProduto } from '../../models/produtos';
import Card from '../Card';
import PainelInteligencia from '../PainelInteligencia';
import ProdutoCard from '../ProdutoCard';
import ProdutoTotalCard from '../ProdutoTotalCard';
import EstadoVazio from '../EstadoVazio';
import { LABEL_AREA } from '../../utils/labels';

interface VisaoExecutivaProps {
  onAbrirAtividade: (id: number) => void;
}

const ORDEM_TIPOS: TipoProduto[] = ['MOTOR_CONCILIACAO', 'MAPA_RESULTADOS', 'REVISOR_CONTABIL', 'WORKFLOW_SOX'];

const VisaoExecutiva: React.FC<VisaoExecutivaProps> = ({ onAbrirAtividade }) => {
  const { produtosIntegrados, recomendacoes, pontuacoes, empresasEscopo, getArea, getEmpresa } = useMaestroContext();
  const [mostrarDetalhe, setMostrarDetalhe] = useState(false);

  const produtosPorTipo = useMemo(() => {
    const mapa = new Map<TipoProduto, ProdutoIntegrado[]>();
    ORDEM_TIPOS.forEach(tipo => mapa.set(tipo, produtosIntegrados.filter(p => p.tipo === tipo)));
    return mapa;
  }, [produtosIntegrados]);

  return (
    <div className='mc-visao-executiva'>
      <Card
        title='Produtos AI Númera — Total do Grupo'
        subtitle={`Consolidado das ${empresasEscopo.length} empresa${empresasEscopo.length > 1 ? 's' : ''} do escopo selecionado.`}
        actions={produtosIntegrados.length > 0 && (
          <button type='button' className='mc-btn mc-btn--secondary mc-btn--sm' onClick={() => setMostrarDetalhe(v => !v)}>
            {mostrarDetalhe ? 'Ocultar detalhamento por empresa' : 'Ver detalhamento por empresa'}
          </button>
        )}
      >
        {produtosIntegrados.length === 0
          ? <EstadoVazio icone='bi bi-box' titulo='Nenhum produto integrado neste escopo' />
          : <div className='mc-produtos-grid'>
              {ORDEM_TIPOS.filter(tipo => (produtosPorTipo.get(tipo) ?? []).length > 0).map(tipo => (
                <ProdutoTotalCard key={tipo} tipo={tipo} produtos={produtosPorTipo.get(tipo) ?? []} />
              ))}
            </div>}
      </Card>

      {mostrarDetalhe && produtosIntegrados.length > 0 && (
        <Card title='Detalhamento por empresa'>
          <div className='mc-produtos-grid'>
            {produtosIntegrados.map(p => (
              <div key={`${p.tipo}-${p.empresaId}`} className='mc-produto-card-wrap'>
                <small className='mc-produto-card-wrap__empresa'>{getEmpresa(p.empresaId)?.nome}</small>
                <ProdutoCard produto={p} />
              </div>
            ))}
          </div>
        </Card>
      )}

      <div className='mc-grid-2'>
        <Card title='Inteligência do Maestro' subtitle='Principais recomendações do ciclo.'>
          <PainelInteligencia recomendacoes={recomendacoes} limite={5} onAbrirAtividade={onAbrirAtividade} />
        </Card>
        <Card title='Resumo por área' subtitle='Pontuação consolidada do ciclo atual.'>
          {pontuacoes.length === 0
            ? <EstadoVazio titulo='Sem pontuação neste ciclo' />
            : <div className='mc-resumo-areas'>
                {pontuacoes.map(p => {
                  const area = getArea(p.areaId);
                  return (
                    <div className='mc-resumo-areas__linha' key={p.id}>
                      <span>{area ? LABEL_AREA[area.tipo] : 'Área'}</span>
                      <div className='mc-progress mc-progress--sm'><div className='mc-progress__track'><div style={{ width: `${p.pontuacaoTotal}%` }} /></div><span>{p.pontuacaoTotal}</span></div>
                    </div>
                  );
                })}
              </div>}
        </Card>
      </div>
    </div>
  );
};

export default VisaoExecutiva;
